import { bodyDataFromMeasurements } from './body-measurement-data';
import { RecordBase, registerInflection } from 'lib/record-base';
import dayjs from 'lib/dayjs';

export class LeaderboardSnapshot extends RecordBase {
  static NAME = 'LeaderboardSnapshot';

  comparisonBody(units, viewerId, latestId, t) {
    const bodyData = bodyDataFromMeasurements(this.measurements);
    bodyData.unitPreference = units === 'metric' ? 1 : 0;
    const mine = this.userId === viewerId;
    const label = this.isGoal ? t('Goal Body') : mine ? t('You') : this.name;
    const subtitle = this.isGoal ? t('Goal') : !mine ? t('Leaderboard') : this.id === latestId ? t('Current Body') : dayjs(this.date).format('MMM D, YYYY');
    return { id: this.id, label, subtitle, bodyData, bodyMode: 'current',
      metrics: this.measurements.metrics || {} };
  }
}
registerInflection('leaderboardSnapshot', 'leaderboardSnapshots', LeaderboardSnapshot);
